import AlertArea from "../prototype/ui/AlertArea.js";
import Commissioning from "../prototype/Commissioning.js";
import Configuration from "../prototype/Configuration.js";
import ConfirmationArea from "../prototype/ui/ConfirmationArea.js";
import Error from "../prototype/utils/Error.js";
import FileInput from "../prototype/utils/FileInput.js";
import global from "../prototype/global.js";
import InputTextArea from "../prototype/ui/InputTextArea.js";
import Internationalization from "../prototype/Internationalization.js";
import Media from "../prototype/utils/Media.js";
import Server from "../prototype/Server.js";
import ToastArea from "../prototype/ui/ToastArea.js";

const log = global.log.getLogger("f_mtac_routes.superadmin");
log.setLevel(log.levels.WARN);

// declare variables for sorting table columns
const tbody = document.querySelector("#organizations_management tbody");
const th_sortable = $("#organizations_management th.sortable");
let table_rows; // = $("tbody tr");

var file_input = new FileInput();
var parser = new DOMParser();

let quotas = {};
let nb_authorized_users_max = 0;
let nb_total_users_allocated = 0;

async function fetch_config() {
    return fetch(global.commissioning.uri.config, {cache: "reload"})
        .then((response) => response.json())
        .catch((error) => log.error(error));
}

// @brief Create an organization with all its attributes and save it in global.datastorage
var Organization = function (org_id, users_count, org_name, max_users) {
    log.debug("new Organization ", {org_id, users_count});

    let $organization = $("<tr/>").attr({id: org_id});
    global.datastorage.put($organization[0], "dataOrganization", this);

    var $org_name = $("<td/>");
    var $org_id = $("<td/>");
    var $users_count = $("<td/>");
    var $logo = $("<td />").attr({class: "logo"});
    let $controls = $("<td/>").append(`
        <div class="dropdown">
            <button type="button" id="actions" class="btn btn-sm btn-dark dropdown-toggle" data-org=${org_id} data-bs-toggle="dropdown" aria-expanded="false">
                <i class="f_mtac-icon-ellipsis-vertical"></i>
            </button>
            <ul id="dropdown_actions" class="dropdown-menu" aria-labelledby="actions">
                <li><a class="dropdown-item" data-i18n-innerhtml="admin.rename" value="rename">${global.internationalization.text("admin.rename")}</a></li>
                <li><a class="dropdown-item" data-i18n-innerhtml="admin.commissioning-upload" value="upload">${global.internationalization.text("admin.commissioning-upload")}</a></li>
                <li><a class="dropdown-item" data-i18n-innerhtml="admin.modify-max-users" value="modify_max_users">${global.internationalization.text("admin.modify-max-users")}</a></li>
                <li><a class="dropdown-item" data-i18n-innerhtml="admin.reset" value="reset">${global.internationalization.text("admin.reset")}</a></li>
                <li><a class="dropdown-item text-danger" data-i18n-innerhtml="admin.delete" value="delete">${global.internationalization.text("admin.delete")}</a></li>
            </ul>
        </div>
    `);

    $organization.append($org_name, $org_id, $users_count, $logo, $controls);

    Object.defineProperties(this, {
        node: {
            set: () => {},
            get: () => $organization
        },
        org_id: {
            set: (new_org_id) => {
                org_id = new_org_id;
                $org_id.text(org_id);
                $org_id.attr({value: org_id}); //used for sorting
            },
            get: () => org_id
        },
        org_name: {
            set: (new_name) => {
                org_name = new_name;
                $org_name.text(org_name);
                $org_name.attr({value: org_name});
            },
            get: () => org_name
        },
        users_count: {
            set: (new_count) => {
                users_count = new_count;
                $users_count.text(users_count + "/" + max_users);
                $users_count.attr({value: users_count});
            },
            get: () => users_count
        },
        max_users: {
            set: (max) => {
                max_users = max;
                $users_count.text(users_count + "/" + max_users);
            },
            get: () => max_users
        }
    });

    //@brief Set the organization's logo from server's logo.svg file
    this.update_logo = async () => {
        log.debug($logo.html());
        global.commissioning.organization = this.org_id;
        return fetch(global.commissioning.uri.logo, {cache: "no-store"})
            .then((response) => response.text())
            .then((str_logo) => $logo.empty().append(parser.parseFromString(str_logo, "application/xml").documentElement))
            .catch((error) => log.error(error));
    };

    // init organization
    this.org_name = org_name;
    this.org_id = org_id;
    this.users_count = users_count;
    this.max_users = max_users || quotas[org_id].org_max_users;
    this.update_logo();
};

const init_language_dropdown = async () => {
    // Set button text
    $("#admin_language").text(global.configuration.internationalization.language.slice(-2));

    // Populate dropdown with available languages
    let languages;
    try {
        languages = await global.server.mtac_language_list();
    } catch (error) {
        log.error("Error while fetching language list", error);
        return;
    }
    let list = "";
    languages = Object.values(languages.data.list);
    languages.forEach((lang) => (lang.text = global.internationalization.text(`language.${lang.name}`)));
    languages.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
    languages.forEach((lang) => (list += `<li><a class="dropdown-item" value="${lang.name}">${lang.text}</a></li>`));
    $("#dropdown_languages").append(list); // modify the DOM just once instead of for each language
};

/**
 *
 * @param {*} tabID "tab1" for organizations ; "tab2" for configuration
 */
function select_tab(tabID) {
    switch (tabID) {
        case "tab1":
            $("#tab2").removeAttr("checked");
            $("#tab1").attr("checked", "checked");
            $("#configuration_panel").hide();
            $("#organizations_management_panel").show();
            break;
        case "tab2":
            $("#tab1").removeAttr("checked");
            $("#tab2").attr("checked", "checked");
            $("#organizations_management_panel").hide();
            $("#configuration_panel").show();
            break;
    }
}

function show_default_admin_password_badge() {
    $("#AdminPwdWarningBadge").show();
    $("#configuration_panel #collapseOne").addClass("show");
    select_tab("tab2");
    // disabe access to organization setting
    $("#tab1").attr("disabled", "");
}

function hide_default_admin_password_badge() {
    $("#AdminPwdWarningBadge").hide();
    $("#configuration_panel #collapseOne").removeClass("show");
    $("#tab1").removeAttr("disabled");
}

const load_organizations = async () => {
    let organizations;
    try {
        organizations = await global.server.mtac_organization_list();
    } catch (error) {
        log.error("error while fetching organization list", error);
        return;
    }
    log.debug(organizations.data.list);

    await load_quotas({});

    // if no org defined: display placeholder and open the creation box
    $("#no-organizations").toggle(organizations.data.list.length === 0);
    $("#orgCreationCollapse").toggleClass("show", organizations.data.list.length === 0);

    let $list = $("#admin_panel tbody");
    let organization;
    for (let {org_id, count} of organizations.data.list) {
        global.commissioning.organization = org_id;
        const config = await fetch_config();
        const org_name = config?.organization?.name || org_id;

        // useful if one day we put reload button
        let $tr = document.getElementById(org_id);
        if ($tr) {
            // organization already displayed, update its attributes
            organization = global.datastorage.get($tr, "dataOrganization");
            organization.org_name = org_name;
            organization.users_count = count;
            organization.update_logo();
        } else {
            // organization not in the table, add it
            organization = new Organization(org_id, count, org_name);
            $list.append(organization.node);
        }
    }
    log.debug("Total number of allocated users:", nb_total_users_allocated);
    table_rows = $("tbody tr");
};

const load_quotas = async () => {
    quotas = {};
    nb_total_users_allocated = 0;
    try {
        (await global.server.superadministration.get_organization_quotas()).forEach((obj) => {
            quotas[obj.org_id] = {org_max_users: obj.org_max_users, org_nb_users: obj.org_nb_users};
            nb_total_users_allocated += obj.org_max_users;
        });
    } catch (error) {
        log.error("error while fetching organizations quota", error);
        return;
    }
    log.debug({quotas, nb_total_users_allocated});
};

const update_quotas = async () => {
    await load_quotas();
    let organization;
    let $tr;
    Object.entries(quotas).forEach((org_id, vals) => {
        $tr = document.getElementById(org_id);
        if ($tr) {
            // element displayed, update its attributes
            organization = global.datastorage.get($tr, "dataOrganization");
            organization.users_count = vals.org_nb_users;
            organization.max_users = vals.org_max_users;
        }
    });
};

function adapt_panel_to_available_height() {
    // Resize admin panel in case of header wrapping
    $("#admin_panel").css("--header_height", $("#admin_panel header").outerHeight() + "px");
}

const init = async () => {
    global.configuration = new Configuration();
    await global.configuration.init();
    global.server = new Server();
    global.server.authentication.auto_register = false;
    await global.server.init();
    await global.app.service_worker.register(); // to profit from application update detection
    global.app.theme.apply_theme(global.app.theme.get_preferred_theme());
    global.commissioning = new Commissioning();
    global.internationalization = new Internationalization(true);
    await global.internationalization.init();

    const submit = async () => {
        const passphrase = $("#admin_login input#password").val();
        try {
            var response = await global.server.superadministration.login({passphrase});
        } catch (error) {
            log.debug(error.status);
            switch (error.status) {
                case Error.status.invalid:
                case Error.status.access:
                case Error.status.auth:
                    $("#admin_login #error_message").text(global.internationalization.text("admin.password-invalid"));
                    break;
                default:
                    $("#admin_login #error_message").text(error.message);
            }
            return;
        }
        if (response.data.default_password_in_use) show_default_admin_password_badge();
        nb_authorized_users_max = response.data.nb_device_max;
        $("#max_enrolments").text(nb_authorized_users_max);
        init_language_dropdown();
        await load_organizations({});
        $("#admin_login").hide();
        $("#admin_panel").show();
        adapt_panel_to_available_height();

        sort_organizations_table(0);
    };

    // Page events handling
    // ----------------------
    window.onresize = () => adapt_panel_to_available_height();

    // Login events handling
    // ----------------------
    $("body").on("click", "#admin_login button", () => {
        submit();
    });

    $("body").on("keydown", "#admin_login input", (event) => {
        $("#admin_login #error_message").text("");
        if (event.key === "Enter") {
            event.preventDefault();
            submit();
        }
    });

    // Navbar events handling
    // ----------------------
    $("body").on("click", "#tabs > input", (event) => select_tab(event.currentTarget.id));

    $("body").on("click", "#dropdown_languages > li", async (event) => {
        log.debug(event);
        const selected_language = event.currentTarget.querySelector(".dropdown-item").getAttribute("value");
        $("#admin_language").text(selected_language.slice(-2));
        await global.internationalization.changeLanguage(selected_language);
    });

    $("body").on("click", "#admin_logout", async () => {
        await global.server.superadministration.logout();
        window.location.replace(`${window.location.origin}/mtac/superadmin`);
    });

    // Create organization event handling
    $("body").on("click.create_organization_form.btn", "#create_organization_form .btn", async () => {
        const org_name = $("#create_organization_form input#organization_name").val();
        let org_max_users = $("#create_organization_form input#nb_user_max").val();
        if (!(org_name && org_max_users)) {
            // TODO: replace by bootstrap's invalid feedback with translation
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.all-parameters-are-mandatory")});
            return;
        }
        log.debug({org_name, org_max_users, nb_total_users_allocated});
        if (nb_total_users_allocated + parseInt(org_max_users) > nb_authorized_users_max) {
            // TODO: replace by bootstrap's invalid feedback
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.enrolment-quota-exceeds-server-limit")});
            return;
        }
        try {
            var response = await global.server.superadministration.create_organization(org_name, org_max_users);
        } catch (error) {
            log.error(error.message);
            switch (error.status) {
                case Error.status.access:
                case Error.status.auth:
                default:
                    AlertArea.interact({
                        type: "danger",
                        tip1: global.internationalization.text("admin.organization-creation-error"),
                        tip2: error.message
                    });
            }
            return;
        }

        ToastArea.interact("success", global.internationalization.text("admin.org-creation-success"));

        nb_total_users_allocated += parseInt(org_max_users);
        log.debug("nb_total_users_allocated ", nb_total_users_allocated);
        $("#create_organization_form input").each((_, input) => (input.value = ""));
        global.commissioning.organization = response.org_id;

        let new_org = new Organization(response.org_id, 0, org_name, org_max_users);
        $("#admin_panel tbody").append(new_org.node);

        $("#no-organizations").hide(); // Hide org table placeholder in case it is displayed.
    });

    // Organizations management events handling
    // ----------------------------------------
    const reset_org_admin_password = async (org_id) => {
        const confirmation = await ConfirmationArea.interact({
            title: global.internationalization.text("global.Confirmation"),
            tip1: global.internationalization.text("admin.reset-confirmation")
        });
        if (!confirmation) return;
        const org_name = global.datastorage.get(document.getElementById(org_id), "dataOrganization").org_name; // why org_name is needed here?
        try {
            await global.server.superadministration.admin_passphrase_reset({org_id, org_name});
        } catch (error) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.reset-failure")});
            return;
        }
        ToastArea.interact("success", global.internationalization.text("admin.admin-password-reset-confirmation"));
    };

    const rename_org = async (org_id) => {
        let organization = global.datastorage.get(document.getElementById(org_id), "dataOrganization");
        const new_name = await InputTextArea.interact({
            tip: global.internationalization.text("admin.organization-rename-title"),
            current_text: organization.org_name,
            capitalized: false,
            validators: {required: true}
        });
        if (!new_name) return;
        log.debug({new_name});
        try {
            await global.server.superadministration.update_organization({org_id, org_name: new_name});
        } catch (error) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.org-rename-failure")});
            return;
        }
        organization.org_name = new_name;
        ToastArea.interact("success", global.internationalization.text("admin.admin-org-rename-confirmation"));
    };

    const delete_org = async (org_id, target) => {
        const confirmation = await ConfirmationArea.interact({
            title: global.internationalization.text("global.Confirmation"),
            tip1: global.internationalization.text("admin.delete-confirmation")
        });
        if (!confirmation) return;
        try {
            await global.server.superadministration.delete_organization({org_id});
        } catch (error) {
            log.error("error ", error);
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.org-delete-failure")});
            return;
        }
        ToastArea.interact("success", global.internationalization.text("admin.admin-org-delete-confirmation"));
        target.parents("tr").remove();
        // once org deleted, remove all org users
        // called here instead of python module because req session id needed to deregister user
        await global.server.superadministration.delete_organization_users({org_id});
    };

    const modify_org_users_max = async (org_id) => {
        let organization = global.datastorage.get(document.getElementById(org_id), "dataOrganization");
        const current_count = organization.users_count;
        const current_quota = organization.max_users;
        const new_quota = await InputTextArea.interact({
            tip: global.internationalization.text("admin.organization-max-users"),
            current_text: current_quota
        });
        if (!new_quota) return;
        if (parseInt(new_quota) < parseInt(current_count)) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.enrolment-quota-too-low")});
            return;
        }
        if (nb_total_users_allocated - parseInt(current_quota) + parseInt(new_quota) > nb_authorized_users_max) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.enrolment-quota-exceeds-server-limit")});
            return;
        }
        const body = [{org_id, org_max_users: parseInt(new_quota)}];
        try {
            await global.server.superadministration.set_organization_quotas(body);
        } catch (error) {
            log.error("error ", error);
            AlertArea.interact({
                type: "danger",
                tip1: global.internationalization.text("admin.enrolment-quota-modification-failure"),
                tip2: error.message
            });
            return;
        }
        ToastArea.interact("success", global.internationalization.text("admin.enrolment-quota-modification-success"));
        organization.max_users = new_quota;
        nb_total_users_allocated = nb_total_users_allocated - parseInt(current_quota) + parseInt(new_quota);
        log.debug({nb_total_users_allocated});
    };

    const handle_file_error = async (error, org_id, accept) => {
        file_input.reset();
        switch (error.status) {
            case Error.status.noctx:
                throw error;
            case Error.status.invalid:
                await AlertArea.interact({
                    type: "danger",
                    tip1: global.internationalization.text("admin.File-selection-invalid-size-too-large"),
                    tip2: global.internationalization.text("admin.File-selection-invalid-select-another")
                });
                break;
            default:
                log.error(error);
                await AlertArea.interact({
                    type: "danger",
                    tip1: global.internationalization.text("admin.File-selection-invalid-unsupported-format"),
                    tip2: global.internationalization.text("admin.File-selection-invalid-select-another")
                });
                break;
        }
        return upload_files(org_id, accept);
    };

    const handle_file = async (file, org_id, accept) => {
        if (file === null) {
            return null;
        }
        try {
            var media = await Media.binary_to_media(file, true);
        } catch (error) {
            if (error.message === "upload file aborted") {
                return null;
            }
            return handle_file_error(error, org_id, accept);
        }
        log.debug("media ", media);
        file_input.reset();
        return media;
    };

    const upload_files = async (org_id, accept) => {
        log.debug("org_id ", org_id);

        var media = null;

        try {
            var file = await file_input.select(accept);
        } catch (error) {
            return handle_file_error(error, org_id, accept);
        }
        log.debug("file ", file);
        if (file === null) return;
        if (file.type !== "application/gzip" && file.type !== "application/x-gzip") {
            await AlertArea.interact({
                type: "danger",
                tip1: global.internationalization.text("admin.File-selection-invalid-unsupported-format"),
                tip2: global.internationalization.text("admin.File-selection-invalid-select-another")
            });
            return upload_files(org_id, accept);
        }
        media = await handle_file(file, org_id, accept);
        media.media_name = file.name;

        try {
            await global.server.superadministration.load_org_file({media_data: media.media_data, media_name: media.media_name, org_id});
        } catch (error) {
            log.error("error ", error);
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.commissioning-upload-failure")});
            return;
        }
        ToastArea.interact("success", global.internationalization.text("admin.commissioning-upload-success"));

        const elem = document.getElementById(org_id);
        if (elem) {
            let organization = global.datastorage.get(elem, "dataOrganization");
            log.debug("organization = ", organization);
            if (organization) {
                const config = await fetch_config();
                organization.org_name = config?.organization?.name;
                // Because of the service worker, we need to reload all organizations
                // & update the logo (with "no-store" option) for the new logo to appear.
                // It is the only configuration that I found that seems to be working.
                load_organizations();
                organization.update_logo();
            }
        }
    };

    $("body").on("click", "#dropdown_actions > li", async (event) => {
        const org_id = $(event.currentTarget).parents("tr").attr("id");
        const selected_action = event.currentTarget.querySelector(".dropdown-item").getAttribute("value");
        log.debug({org_id, selected_action});
        switch (selected_action) {
            case "rename":
                await rename_org(org_id);
                break;
            case "upload":
                await upload_files(org_id, "application/x-gzip");
                break;
            case "modify_max_users":
                // first update org quotas in case it has been changed by someone else
                await update_quotas();
                await modify_org_users_max(org_id);
                break;
            case "reset":
                await reset_org_admin_password(org_id);
                break;
            case "delete":
                await delete_org(org_id, $(event.currentTarget));
                break;
        }
    });

    // Manage sorting of columns
    // -------------------------

    // @brief row comparison based on text content
    // @param col index of the column to be sorted
    // @param asc true for ascendant, false for descendant
    function compare(col, asc) {
        // @params row1 and row2 are provided by the sort() method
        return function (row1, row2) {
            const tdValue = (row, col) => row.children[col].getAttribute("value");
            let v1 = tdValue(asc ? row1 : row2, col);
            let v2 = tdValue(asc ? row2 : row1, col);
            const compare_numbers = typeof v1 === "number" && typeof v2 === "number";
            return compare_numbers ? v1 - v2 : v1.toString().localeCompare(v2);
        };
    }

    function sort_organizations_table(col_index) {
        // apply sorting on given column
        const sorted = Array.from(table_rows).sort(compare(col_index, (this.asc = !this.asc)));
        sorted.forEach((tr) => tbody.appendChild(tr));

        // update sorting icons
        $("th.sortable i").css("display", "none");
        const icon = $("th.sortable i")[col_index];
        icon.className = this.asc ? "f_mtac-icon-angle-up-white" : "f_mtac-icon-angle-down-white";
        icon.style.display = "inline-flex";
    }

    // Add sorting feature on table titles when clicked
    th_sortable.on("click", (event) => sort_organizations_table(event.currentTarget.cellIndex));

    // Configuration events handling
    // -----------------------------
    $("body").on("click.admin_password_form.btn", "#admin_password_form .btn", async () => {
        const old_password = $("#admin_password_form input#old_admin_password").val();
        const new_password = $("#admin_password_form input#new_admin_password").val();
        const repeat_new_password = $("#admin_password_form input#repeat_new_admin_password").val();
        if (old_password === "") $("#admin_password_form input#old_admin_password").addClass("is-invalid");
        if (new_password === "") $("#admin_password_form input#new_admin_password").addClass("is-invalid");
        if (new_password !== repeat_new_password) $("#admin_password_form input#repeat_new_admin_password").addClass("is-invalid");
        if (old_password === "" || new_password === "" || new_password !== repeat_new_password) return;
        try {
            log.debug({old_password, new_password, repeat_new_password}, $("#admin_password_form input.is-invalid"));
            var response = await global.server.superadministration.superadmin_passphrase({old_password, new_password});
        } catch (error) {
            log.error(error.message);
            switch (error.status) {
                case Error.status.access:
                case Error.status.auth:
                    $("#enrolment_password_form input#admin_password").addClass("is-invalid");
                    break;
                default:
                    AlertArea.interact({
                        type: "danger",
                        tip1: "The enrollment password could not be changed. Please try again.",
                        tip2: error.message
                    });
            }
            return;
        }
        $("#admin_password_form input").each((_, input) => (input.value = ""));
        hide_default_admin_password_badge();
        if (response.data.default_password_in_use) show_default_admin_password_badge();
        ToastArea.interact("success", global.internationalization.text("admin.admin-password-modification-confirmation"));
    });
    $("body").on("keydown.admin_password_form.input", "#admin_password_form input", (event) => {
        $(event.currentTarget).removeClass("is-invalid");
    });

    // Display form only when ready to avoid test issue
    $("#admin_login form").show();
};
var finalize = () => {};

export default {init, finalize};
